module.exports = __webpack_public_path__ + "img/jarvis-logo.8aabd0ae.png";